import React from 'react'
import { Accordion } from '@softura/customcomponent'
import './Accordion.scss'

interface IProps {
  Items?: any,
  className?: any,
  uuid?: any,
  allowZeroExpanded?:any,
  allowMultipleExpanded?:any,
  preExpanded?:any,
  onChange?:any,
}

const AccordionComponent = ({ Items = [], className = '', uuid,preExpanded ,onChange}:IProps) => {
  return <Accordion
  items = {Items}
  className = {`accodion-container ${className}`}
  uuid = {uuid}
  allowMultipleExpanded = "true"
  allowZeroExpanded = "true"
  preExpanded={preExpanded}
  onChange ={onChange}
/>
}

export default AccordionComponent
